import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container-fluid"
}
const _hoisted_2 = {
  key: 1,
  class: ""
}
const _hoisted_3 = {
  class: /*@__PURE__*/_normalizeClass('main-content d-flex flex-column transition overflow-hidden')
}

import { defineComponent, watchEffect, onMounted, reactive } from "vue";
import { useRoute } from "vue-router";
import stateStore from "./utils/store";
import { useUserStore } from "@/stores/userStore";
import storeCliente from "./utils/storeCliente";
import { getToken } from "./utils/funcoes";
import * as service from "./services/usuariosService";

import MainHeader from "./components/Layouts/MainHeader.vue";
import MainSidebar from "./components/Layouts/MainSidebar.vue";
import MainFooter from "./components/Layouts/MainFooter.vue";

import LoginCliente from "./cliente/Login.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


const userStore = useUserStore();
const stateStoreInstance = stateStore;
const route = useRoute();

var controle = reactive({
  rota: "",
})

onMounted(() => {
  console.log("montando 2...");
  document.body.classList.add("bg-body-secondary");

  userStore.setToken(service.getToken());

  const x = localStorage.getItem('user');

  if (x != null) {
    const user = JSON.parse(x);
    userStore.setUser(user);
  }

  controle.rota = String(route.name || "");

  setInterval(() => {
    //verificaEstaLogado();
  }, 60000); // Verifica a cada 60 segundos

})

watchEffect(async () => {
  if (stateStoreInstance.open) {
    document.body.classList.remove("sidebar-show");
    document.body.classList.add("sidebar-hide");
  } else {
    document.body.classList.remove("sidebar-hide");
    document.body.classList.add("sidebar-show");
  }
})

function getTokenCliente() {
  const x = localStorage.getItem("clienteToken");

  if (x != null) {
    return x;
  }
  return "";
}

async function verificaEstaLogado() {

  try {
      var logado = await service.estaLogado();
      if (logado == true) {
        console.log("Usuário está logado.");
      } else {
        var sair = await service.logout();
        console.log("Logout realizado com sucesso.");
        window.location.reload();
      }
  } catch (error) {
    console.error("Erro ao obter o token:", error);
    return;
  }


}


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_unref(controle).rota == '/cliente')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(LoginCliente)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        (_unref(userStore).token != '')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(MainHeader),
              _createVNode(MainSidebar),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_router_view),
                _createVNode(MainFooter)
              ])
            ], 64))
          : (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
      ]))
}
}

})